<div class="summary-card">

  <div class="header">
    <div class="title">
      <i class="bi bi-file-earmark-text"></i>
      <span>Summary</span>
    </div>

    <ng-container *hasPermission="PermissionForStudents.RESUME_SUGGEST">
   <button class="generate-btn" 
        (click)="postAIGeneratedSummary()" 
        [disabled]="isLoading">

  <ng-container *ngIf="isLoading; else normalText">
    <span class="spinner-border spinner-border-sm"></span>
    Generating...
  </ng-container>

  <ng-template #normalText>
    <i class="bi bi-stars"></i>
    {{ isGenerated ? 'Regenerate Suggestions' : 'Auto-Generate' }}
  </ng-template>

</button>
   </ng-container>
  </div>

  <h3 class="sub-title">Professional Summary</h3>

  <div *ngIf="isGenerated" class="suggestions">
    <p class="choose-text">Choose a summary or edit below:</p>

    <label class="option" *ngFor="let item of suggestions">
      <input type="radio" name="summary" (change)="selectSummary(item)" />
      <span>{{ item }}</span>
    </label>
  </div>

  <textarea
    [(ngModel)]="summaryText"
    placeholder="Write a 2-3 line summary about yourself, your skills, and what you're looking for..."
     maxlength="500">
</textarea>

  <div class="tips">
    <p><b>Tips for a great summary:</b></p>
    <ul>
      <li>Keep it under 3 sentences</li>
      <li>Mention your degree, key skills, and career goal</li>
      <li>Avoid generic phrases like "hardworking individual"</li>
      <li>Use action words: "passionate about", "skilled in", "seeking"</li>
    </ul>
  </div>

<div 
  class="char-count"
  [class.limit]="summaryText.length > 450"
>
  Characters: {{ summaryText.length }} / 500
</div>
</div>